// extracted by mini-css-extract-plugin
export default {"PfsVIAA":"PFSVIAA_PfsVIAA__eQQq-","content":"PFSVIAA_content__YyQXX","homeBtn":"PFSVIAA_homeBtn__RncMR","logo":"PFSVIAA_logo__93DyP"};